import { PageHeader } from "components/ui";
import React from "react";
import { Grid, Typography, Box } from "@mui/material";
import { fontFamily, fontSize } from "../../../node_modules/@mui/system/index";
import CustomButton from "components/buttonsComponent/StyledButton";
import NavigationButtons from "helper/navigation/NavigationButtons";
import DownloadZipButton from "components/buttonsComponent/DownloadZipButton";

const WhatisIfcPSs = () => {
  const urlConfig = {
    name: "IFC.zip",
    downloadUrl: "https://demo.sustainesg.ca/pdf/IFC.zip",
  };
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
          <PageHeader title="AI-Powered ESG Reporting across Global, National, Sectoral, and Industry-Specific Standards" />
        </Box>
      </Grid>

      <Grid item xs={12}>
        <Box className="gri-header">
          <NavigationButtons
            imageKey="IFC PSs"
            title={"IFC Reporting"}
            activeStep={0}
          />
        </Box>
      </Grid>
      <Grid item xs={12}>
        <Box
          sx={{
            borderRadius: "8px",
            padding: "24px",
            top: "226px",
            left: "75px",
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontWeight: 700,
              color: "#2E7D32",
              mb: 3,
              fontFamily: "DM Sans",
              fontSize: "40px",
              lineHeight: "38px",
            }}
          >
            The global standards for sustainability
            <br /> impacts
          </Typography>

          <Box sx={{ mb: 2 }}>
            <Typography
              component="h4"
              sx={{
                fontFamily: "DM Sans",
                fontWeight: 800,
                fontSize: "20px",
                lineHeight: "28px",
                letterSpacing: "-2%",
                color: "#4F4F4F",
                mb: 1,
              }}
            >
              What are IFC Performance Standards — Brief introduction
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontFamily: "DM Sans",
                fontWeight: 400,
                fontSize: "20px",
                lineHeight: "28px",
                letterSpacing: "-2%",
                color: "#4F4F4F",
                marginBottom: "16px",
              }}
            >
              IFC Performance Standards are a set of internationally recognized
              benchmarks developed by the International Finance Corporation
              (IFC) to guide companies and projects in identifying, managing,
              and mitigating environmental and social (E&S) risks. They define
              expectations for companies to avoid, minimize, and manage negative
              impacts on people and the environment, and provide a framework for
              assessing E&S risks and opportunities, particularly in high-impact
              industries or projects receiving IFC investment.
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontFamily: "DM Sans",
                fontWeight: 400,
                fontSize: "20px",
                lineHeight: "28px",
                letterSpacing: "-2%",
                color: "#4F4F4F",
                marginBottom: "16px",
              }}
            >
              The standards promote sustainable outcomes by ensuring responsible
              business practices that respect human rights, biodiversity, local
              communities, and labor standards.
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontFamily: "DM Sans",
                fontWeight: 400,
                fontSize: "20px",
                lineHeight: "28px",
                letterSpacing: "-2%",
                color: "#4F4F4F",
                marginBottom: "16px",
              }}
            >
              The eight IFC Performance Standards cover:
            </Typography>
            <ul>
              <Typography
                component="li"
                variant="body1"
                sx={{
                  fontFamily: "DM Sans",
                  fontWeight: 400,
                  fontSize: "20px",
                  lineHeight: "28px",
                  letterSpacing: "-2%",
                  color: "#4F4F4F",
                }}
              >
                PS1: Assessment and Management of Environmental and Social Risks
                and Impacts
              </Typography>
              <Typography
                component="li"
                variant="body1"
                sx={{
                  fontFamily: "DM Sans",
                  fontWeight: 400,
                  fontSize: "20px",
                  lineHeight: "28px",
                  letterSpacing: "-2%",
                  color: "#4F4F4F",
                }}
              >
                PS2: Labor and Working Conditions
              </Typography>
              <Typography
                component="li"
                variant="body1"
                sx={{
                  fontFamily: "DM Sans",
                  fontWeight: 400,
                  fontSize: "20px",
                  lineHeight: "28px",
                  letterSpacing: "-2%",
                  color: "#4F4F4F",
                }}
              >
                PS3: Resource Efficiency and Pollution Prevention
              </Typography>
              <Typography
                component="li"
                variant="body1"
                sx={{
                  fontFamily: "DM Sans",
                  fontWeight: 400,
                  fontSize: "20px",
                  lineHeight: "28px",
                  letterSpacing: "-2%",
                  color: "#4F4F4F",
                }}
              >
                PS4: Community Health, Safety, and Security
              </Typography>
              <Typography
                component="li"
                variant="body1"
                sx={{
                  fontFamily: "DM Sans",
                  fontWeight: 400,
                  fontSize: "20px",
                  lineHeight: "28px",
                  letterSpacing: "-2%",
                  color: "#4F4F4F",
                }}
              >
                PS5: Land Acquisition and Involuntary Resettlement
              </Typography>
              <Typography
                component="li"
                variant="body1"
                sx={{
                  fontFamily: "DM Sans",
                  fontWeight: 400,
                  fontSize: "20px",
                  lineHeight: "28px",
                  letterSpacing: "-2%",
                  color: "#4F4F4F",
                }}
              >
                PS6: Biodiversity Conservation and Sustainable Management of
                Living Natural Resources
              </Typography>
              <Typography
                component="li"
                variant="body1"
                sx={{
                  fontFamily: "DM Sans",
                  fontWeight: 400,
                  fontSize: "20px",
                  lineHeight: "28px",
                  letterSpacing: "-2%",
                  color: "#4F4F4F",
                }}
              >
                PS7: Indigenous Peoples
              </Typography>
              <Typography
                component="li"
                variant="body1"
                sx={{
                  fontFamily: "DM Sans",
                  fontWeight: 400,
                  fontSize: "20px",
                  lineHeight: "28px",
                  letterSpacing: "-2%",
                  color: "#4F4F4F",
                }}
              >
                PS8: Cultural Heritage
              </Typography>
            </ul>
            <Typography
              variant="body1"
              sx={{
                fontFamily: "DM Sans",
                fontWeight: 400,
                fontSize: "20px",
                lineHeight: "28px",
                letterSpacing: "-2%",
                color: "#4F4F4F",
                marginTop: "16px",
              }}
            >
              They are widely used by IFC clients, private sector lenders, and
              development finance institutions globally to align project
              operations with best practices for sustainability, risk reduction,
              and stakeholder engagement.
            </Typography>
          </Box>
        </Box>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <DownloadZipButton
            config={urlConfig}
            title="Access to full IFC PSs"
          />
        </Box>
      </Grid>
    </Grid>
  );
};

export default WhatisIfcPSs;
